import moment from 'moment';

import constants from '@/constants';

import db from '@/store/db';

import { apiLog } from './namespace';

export const fetchEntities = async () => {
  try {
    const { rows } = await db.organisationDb.query('companyFiles', { include_docs: true });
    return rows.map(({ doc }) => doc);
  } catch (error) {
    apiLog('fetchEntities', 'Unable to load company files list', error);
    throw error;
  }
};

export const fetchEntityByCompanyId = async ({ companyId }) => {
  if (!companyId) {
    apiLog('fetchEntityByCompanyId', 'Missing companyId');
    throw new Error('Failed to fetch Company Files due to invalid params');
  }

  try {
    const params = { key: companyId, limit: 1, include_docs: true };
    const { rows } = await db.organisationDb.query('companyFiles', params);
    const row = rows && rows.find(({ doc }) => doc.companyId === companyId);

    return (row && row.doc) || null;
  } catch (error) {
    apiLog('fetchEntityByCompanyId', `Unable to load company files document for companyId "${companyId}"`, error);
    throw error;
  }
};

export const createEntity = async ({ companyId, projectFiles }) => {
  if (!companyId) {
    apiLog('createEntity', 'Missing companyId');
    throw new Error('Failed to create company files due to invalid params');
  }

  const now = moment.utc().format(constants.formats.dateTimeUtc);
  const params = {
    type: 'CompanyFiles',
    companyId,
    projectFiles: projectFiles == null || typeof projectFiles !== 'object' ? {} : projectFiles,
    createdAt: now,
    updatedAt: now,
  };

  try {
    return await db.organisationDb.post(params);
  } catch (error) {
    apiLog('createEntity', `Unable to create Company Files document for companyId "${companyId}"`, error);
    throw error;
  }
};

export const updateEntity = async ({ _id, _rev, companyId, projectFiles, createdAt, ...entity }) => {
  if (!_id || !_rev || !companyId) {
    apiLog('updateEntity', 'Invalid params', { _id, _rev, companyId });
    throw new Error('Failed to update company files due to invalid params');
  }

  const now = moment.utc().format(constants.formats.dateTimeUtc);
  const params = {
    ...entity,
    _id,
    _rev,
    companyId,
    projectFiles: projectFiles == null || typeof projectFiles !== 'object' ? {} : projectFiles,
    createdAt: createdAt || now,
    updatedAt: now,
  };

  try {
    return await db.organisationDb.put(params);
  } catch (error) {
    apiLog('updateEntity', `Unable to update Company Files document for companyId "${companyId}"`, error);
    throw error;
  }
};

export default {
  fetchEntities,
  fetchEntityByCompanyId,
  createEntity,
  updateEntity,
};



// WEBPACK FOOTER //
// ./src/store/companyFiles/api.js